import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import adminRoutes from './admin'

import { projectAuth, projectFirestore } from '@/firebase/config'
import { collection, getDocs, query, where } from 'firebase/firestore'
import DashBoard from '@/views/DashBoard.vue'
import EventList from '@/views/EventList.vue'
import GuestList from '@/views/GuestList.vue'
import Login from '@/views/login.vue'
import RegisterView from '@/views/RegisterView.vue'
import ExpenseList from '@/views/ExpenseList.vue'
import ForgotPassword from '@/views/ForgotPassword.vue'


/* --------------------------------------------------
   Helper: get user role from Firestore
-------------------------------------------------- */
const getUserRole = async (email) => {
  const q = query(
    collection(projectFirestore, 'users'),
    where('email', '==', email)
  )

  const snapshot = await getDocs(q)

  if (!snapshot.empty) {
    return snapshot.docs[0].data().role
  }

  return null
}

/* --------------------------------------------------
   Routes
-------------------------------------------------- */
const routes = [
  {
    path: '/',
    component: HomeView,
    children: [
      {
        path: '',
        name: 'dashboard',
        component: DashBoard
      },
      {
        path: 'events',
        name: 'events',
        component: EventList
      },
      {
        path: 'events/:id/guests',
        name: 'event-guests',
        component: GuestList,
        props: true
      },
      {
        path: 'events/:id/expenses',
        name: 'event-expenses',
        component: ExpenseList,
        props: true
      }

    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/',
  },
  ...adminRoutes, // /admin routes
]

/* --------------------------------------------------
   Router
-------------------------------------------------- */
const router = createRouter({
  history: createWebHistory(),
  routes,
})

/* --------------------------------------------------
   GLOBAL GUARD (AUTH + ROLE)
-------------------------------------------------- */
router.beforeEach(async (to, from, next) => {
  const user = projectAuth.currentUser

  // 🔒 Not logged in
  if (!user) {
    if (to.path === '/login' || to.path === '/register' || to.path === '/forgot-password') {
      return next()
    }
    return next('/login')
  }

  // ✅ Logged in → get role
  const role = await getUserRole(user.email)

  // 👤 USER tries to access ADMIN
  if (role === 'User' && to.path.startsWith('/admin')) {
    return next('/')
  }

  // 👑 ADMIN goes to home
  if (role === 'Admin' && to.path === '/') {
    return next('/admin')
  }

  // 🚫 Logged in user goes to login/register
  if (to.path === '/login' || to.path === '/register') {
    return role === 'Admin' ? next('/admin') : next('/')
  }

  next()
})

export default router